<template>
    <div class="page" style="background-color: hsla(0, 0%, 96%, 1); ">

        <div style="height: 46px;">
            <header class="pageHeader detailPageHeader paddingH16 paddingV8 white_bg lightGreyBottomBorder" style="line-height: 30px;">
                <div class="borderLayout">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 3px;" @click="back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold"
                             style="height: 30px; overflow: hidden">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px">
                            <a href="javascript:;" @click="share()">
                                <img class="icon shareIcon size22 alignBottom" src="icon/black_share_icon.png"/>
                            </a>
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <div class="body">
            <div class="imageArea">
                <img class="block" :src="dataItem ? dataItem.coverImg : ''"/>
            </div>
            <div class="padding16 white_bg">
                <div class="font18r bold" style="color: hsla(232, 7%, 22%, 1);
                    margin-bottom: 18px; line-height: 1em;">
                    {{ dataItem ? dataItem.title : '' }}
                </div>
                <div class="font12r" style="padding-bottom: 16px;">
                    <span style="color: hsla(0, 0%, 53%, 1);">
                        {{ dataItem ? formatDate(dataItem.liveDate) : '' }}
                    </span>
                    <span style="color: hsla(0, 0%, 53%, 1); margin-left: 24px;">
                        共{{ dataItem ? dataItem.itemCount : '??' }}场
                    </span>
<!--                    <span class="fr" style="color: hsla(232, 7%, 22%, 1)">-->
<!--                        {{ dataItem ? dataItem.subscribeCount : '??' }}人预约-->
<!--                    </span>-->
                </div>
            </div>
            <div class="marginT8 white_bg">
                <div class="generalPagePaddingH">
                    <div class="paddingV16 title bold" style="color: hsla(0, 0%, 17%, 1)">
                        直播列表
                    </div>
                    <div class="liveList" style="padding-bottom: 16px;">
                        <div class="liveItem relative" :class="{active : sectionItem.status == liveTelecastStatusEnum.IN_LIVE.code}"
                            v-for="(sectionItem, index) in dataItem ? dataItem.itemList : []" :key="index">
                            <div class="flexLayout" style="padding: 16px 10px 16px 16px;">
                                <div class="flexItem" style="line-height: 1.28em;">
                                    <span class="bold font14r weekDayText">
                                        {{ sectionItem.startTimeWeekDay }}
                                    </span>
                                    <span class="bold font14r timeText" style="margin-left: 12px;">
                                        {{ sectionItem.startTimeMinute }}
                                    </span><br/>
                                    <span class="bold font12r dateText">
                                        {{ sectionItem.startTimeYearMonthDay }}
                                    </span>
                                </div>
                                <div style="width: 68px; margin-left: 16px; padding-top: 8px;">
                                    <button class="button orangeSolidButton"
                                        v-show="sectionItem.status == liveTelecastStatusEnum.IN_LIVE.code"
                                        @click="watch(sectionItem)">
                                        进入直播
                                    </button>
                                    <button class="button orangeHollowButton" :disabled="sectionItem.isSubscribe"
                                        v-show="sectionItem.status == liveTelecastStatusEnum.BEFORE_LIVE.code"
                                        @click="subscribe(sectionItem)">
                                        {{ sectionItem.isSubscribe ? '已预约' : '预约直播' }}
                                    </button>
                                    <button class="button greyHollowButton" disabled=""
                                        v-if="sectionItem.status == liveTelecastStatusEnum.AFTER_LIVE.code">
                                        直播结束
                                    </button>
                                </div>
                            </div>
                            <i class="icon inLiveIcon" v-show="sectionItem.status == liveTelecastStatusEnum.IN_LIVE.code"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div class="marginT8 white_bg" style="padding-bottom: 59px;">
                <div class="generalPagePaddingH">
                    <div class="paddingV16 title bold" style="color: hsla(0, 0%, 17%, 1)">
                        直播详情
                    </div>
                    <article class="article introArea" v-html="dataItem ? dataItem.introduction : ''">

                    </article>
                </div>
            </div>
        </div>

<!--        <distributeButton @sharePoster="sharePoster()"/>-->

        <liveTelecastDetailDrawer ref="liveTelecastDetailDrawer"
          :liveTelecastData="selectedSectionItem"/>

        <bookSuccessMessageBox ref="bookSuccessMessageBox"/>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from '@/appConfig';

// data
import liveTelecastStatusEnum from '@data/liveTelecastStatusEnum';

// modules
import liveTelecastDetailDrawer from '@pages/liveTelecast/liveTelecastDetailDrawer';
import bookSuccessMessageBox from './bookSuccessMessageBox';
import distributeButton from '@/components/distribution/distributeButton';

// util
import appHelper    from '@/util/appHelper';
import wechatHelper from '@/util/wechatHelper';
import liveApi      from "./liveApi";
import userUtil     from "@comp/shixunApp/userUtil";

const config = {
    apiConfig : {
        get : {
            url : 'portal/live/get',
            dataColumnMapping : {
                // userName : 'name'
            }
        }
    }
};

export default {
    name: "liveTelecastDetail",
    extends : shixunPagePart,
    components : {
        liveTelecastDetailDrawer, bookSuccessMessageBox, distributeButton
    },
    data () {
        return {
            title : '',
            pageKey: 'live-details',
            apiConfig : config.apiConfig,
            enableDataItem : true,
            autoLoadDataItem : appConfig.mode !== 'demo',
            liveTelecastStatusEnum : liveTelecastStatusEnum,
            selectedSectionItem : null,

            userInstance : null
        }
    },
    methods : {
        onLoadDataItem : function () {

            // set wechat share
            let appName = appConfig.name || '';

            this.title          = this.dataItem.title;
            this.description    = this.dataItem.description || '';
            // desc.length > 20 ? desc = desc.substr(0, 20) : null;

            appHelper.setTitle(this.dataItem.title);

            // set wechat share
            let link = '';

            if (!this.userInstance)
            {
                link = appHelper.generateShareUrl('/liveTelecast/' + this.dataItem.id);
            }
            else
            {
                link = appHelper.generateShareUrl('/liveTelecast/:id/promotion/:promotionCode', {
                    ':id' : this.dataItem.id,
                    ':promotionCode' : this.userInstance.introduceCode
                });
            }

            const wechatShareOptions = {
                title   : appHelper.getTitle(),
                desc    : this.description,
                imgUrl  : appHelper.getAppIcon() // 分享图标
            };
            this.setWechatShare(wechatShareOptions);
        },
        subscribe(sectionItem) {

            this.selectedSectionItem = sectionItem;

            if (sectionItem.isSubscribe)
            {
                appHelper.showHint('已预约');
                return;
            }

            liveApi.subscribe(sectionItem.id, () => {
                // appHelper.showHint('预约成功');

                this.$refs.bookSuccessMessageBox.show();

                this.reloadDataItem();
            });
        },
        watch(sectionItem) {

            this.selectedSectionItem = sectionItem;

            switch (sectionItem.addressType)
            {
                case 1:     // to url
                    appHelper.redirect(sectionItem.liveAddress);
                    break;
                case 2:     // show qr image
                    this.$refs.liveTelecastDetailDrawer.open();
                    break;
            }
        },
    },
    mounted() {
        const promotionCode   = this.$route.params.promotionCode || '';

        appHelper.checkLogin((error, result) => {

            if (error)
            {
                return;
            }
            if (result)
            {
                this.userInstance = userUtil.createUser(result);
                this.setWechatShare({
                    params : {
                        promotionCode : result.introduceCode
                    }
                });
            }
            else {
                this.setWechatShare();
            }
        }, {
            promotionCode : promotionCode
        });
    }
}
</script>

<style lang="scss" scoped>
.orangeSolidButton {
    width: 64px;
    height: 26px;
    box-sizing: border-box;
    line-height: 26px;
    background: #FFA724;
    border: 1px solid #FFA724;
    border-radius: 4px;

    color: #FFFFFF;
    padding: 0;

    font-size: 12px;

    &:disabled {
        opacity: .5;
    }
}
.orangeHollowButton {
    width: 64px;
    height: 26px;
    box-sizing: border-box;
    line-height: 26px;
    border: 1px solid #FFA724;
    border-radius: 4px;
    padding: 0;

    color: #FFA724;
    font-size: 12px;
}
.greyHollowButton {
    width: 68px;
    height: 26px;
    box-sizing: border-box;
    line-height: 26px;

    border: 1px solid #B8C2D6;
    border-radius: 4px;
    padding: 0;

    color: hsla(220, 27%, 78%, 1);
    font-size: 14px;
}
.liveList {
    .liveItem {

        background-color: hsla(230, 30%, 96%, 1);
        border-radius: 4px;
        margin-bottom: 8px;

        .weekDayText, .timeText {
            color: hsla(0, 0%, 7%, 1);
        }
        .dateText {
            color: hsla(219, 9%, 39%, 1);
        }
    }
    .liveItem:last-child {
        margin-bottom: 0;
    }
    .liveItem.active {
        .weekDayText, .timeText, .dateText {
            color: hsla(36, 100%, 57%, 1);
        }
    }
}
.inLiveIcon {
    position: absolute;
    z-index: 1;
    left: 0;
    top: 0;
    width: 45px;
    height: 12px;
    background-image: url('data:image/png;base64,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');
}
</style>
